module.exports = __webpack_public_path__ + "static/media/91GRfDGDJIL._AC_SL1500_.532c38c3.jpg";